export default __webpack_public_path__ + "static/media/zeit.b32ad470.jpg";